<template>
    <div>
        <join-header :actIndex="actIndex" :imgList="imgList" :topStyle="topStyle" :logo="logo"></join-header>
        <join-job :jobList="jobInfo" ref="jobRef"></join-job>
        <join-footer :bottom="bottom" :bottomInfo="contactInfo"></join-footer>
    </div>
</template>

<script>
import JoinHeader from '@/components/mobile/Header'
import JoinJob from '@/components/mobile/JoinJob'
import JoinFooter from '@/components/mobile/Footer'
export default {
    name: 'JoinUs',
    data () {
        return {
            actIndex: 5,
            topStyle: "",
            imgList: [],
            bottom: {},
            logo: '',
            contactInfo: {},
            jobInfo: []
        }
    },
    components: {
        JoinHeader,
        JoinJob,
        JoinFooter,
    },
    mounted () {
        this.Pc_Mobile()
        this.getPageData()
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        Pc_Mobile () {
            if(this._isMobile()) {
                this.$router.replace('/m_joinus');
            }else{
                this.$router.replace('/joinus');
            }
        },
        getPageData () {
            this.$http.post('home/index/m_joinus',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background:url('"+this.$imgUrl+res.data.header[0].m_jrwm.replace(/\\/g,'/')+"')"
                this.contactInfo = res.data.contact[0]
                this.jobInfo = res.data.recruit
                this.$nextTick(()=>{
                    this.$refs.jobRef.imgSwiper()
                })
            })
        },
    }
}
</script>

<style lang="stylus" scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/JoinUs.vue